// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__3StTv","formItems":"FormHeader_formItems__vM0Lo"};